import MaskedInput from './MaskedInput'

export default MaskedInput



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/MaskedInput/index.js